import { useEffect, useState } from 'react';

const API = `${window.location.origin}/api`;

export const DEFAULT_PRICING = {
  is_early_access: true,
  lifetime_price: 67,
  lifetime_regular_price: 97,
  upgrade_price: 58,
  upgrade_regular_price: 88,
  trial_price: 9,
  trial_days: 7,
  early_access_label: 'Early Access',
  early_access_end_label: 'November 1',
  urgency_line: 'Early access pricing ends November 1.',
  early_access_end_at: '2026-11-01T23:59:59-04:00',
};

let cached = null;

export function usePricing() {
  const [pricing, setPricing] = useState(cached || DEFAULT_PRICING);
  useEffect(() => {
    if (cached) return;
    fetch(`${API}/pricing`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => { if (data) { cached = data; setPricing(data); } })
      .catch(() => {});
  }, []);
  return pricing;
}
